var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92266 18.9474C0.953188 18.9474 0.525819 18.2432 0.972135 17.3827L9.1874 1.56423C9.63371 0.703705 10.3653 0.703705 10.8121 1.56423L19.0274 17.3827C19.4748 18.2432 19.0469 18.9474 18.0769 18.9474H1.92266Z",
    fill: "#FFC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0773 6.92387C9.0773 6.35332 9.47458 6.00012 10 6.00012C10.513 6.00012 10.9231 6.36691 10.9231 6.92387V12.1552C10.9231 12.7122 10.513 13.079 10 13.079C9.47458 13.079 9.0773 12.7254 9.0773 12.1552V6.92387ZM9 14.9401C9.00044 14.6591 9.10595 14.3898 9.2934 14.1912C9.48085 13.9926 9.73496 13.8808 10 13.8805C10.265 13.8808 10.5191 13.9926 10.7066 14.1912C10.8941 14.3898 10.9996 14.6591 11 14.9401C10.9997 15.2211 10.8942 15.4905 10.7067 15.6893C10.5193 15.888 10.2651 15.9998 10 16.0001C9.73488 15.9998 9.48072 15.888 9.29326 15.6893C9.10579 15.4905 9.00033 15.2211 9 14.9401Z",
    fill: "#27387D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalWarning);
export default __webpack_public_path__ + "static/media/modal_warning.c57d6b66d4ee55b2f1ef0463aa52f2d9.svg";
export { ForwardRef as ReactComponent };